import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useGlobalData } from "../context/GlobalDataContext";
import { fetchFooterLinks } from "../api/api";
import "./FooterNav.css";

// Robust touch device detection (user agent + touch capability)
function isTouchDevice() {
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  // Touch capability detection
  const hasTouch = (
    'ontouchstart' in window ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0)
  );
  // User agent detection
  const isMobileUA = mobileRegex.test(navigator.userAgent);
  // Return true if either is true
  return hasTouch || isMobileUA;
}

// Helper to check if link is external
function isExternalLink(url) {
  return /^https?:\/\//i.test(url);
}

const DEFAULT_FOOTER_TITLES = {
  quick: "Quick Links",
  another: "Popular Links",
  more: "Resources",
  additional: "Support"
};


function Footer() {
  const { footerLinks } = useGlobalData?.() || {};
  const [footerData, setFooterData] = useState({
    titles: DEFAULT_FOOTER_TITLES,
    quick: [],
    another: [],
    more: [],
    additional: []
  });

  useEffect(() => {
    // Prefer context data if available
    if (footerLinks && (footerLinks.quick?.length || footerLinks.another?.length || footerLinks.more?.length || footerLinks.additional?.length)) {
      setFooterData({
        ...footerLinks,
        titles: {
          ...DEFAULT_FOOTER_TITLES,
          ...(footerLinks.titles || {})
        }
      });
    } else {
      // Fallback to API if not in context
      const loadData = async () => {
        try {
          const res = await fetchFooterLinks();
          setFooterData({
            ...res.data,
            titles: {
              ...DEFAULT_FOOTER_TITLES,
              ...(res.data?.titles || {})
            }
          });
        } catch (err) {
          console.error("Error loading footer links:", err);
        }
      };
      loadData();
    }

    // Minimal, reliable Google Translate widget integration:
    if (!window.googleTranslateElementInit) {
      window.googleTranslateElementInit = function() {
        if (window.google && window.google.translate) {
          new window.google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
        }
      };
    }
    if (!document.getElementById('google-translate-script')) {
      const script = document.createElement('script');
      script.id = 'google-translate-script';
      script.type = 'text/javascript';
      script.async = true;
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      document.body.appendChild(script);
    }
    if (!document.getElementById('google-translate-script')) {
      const script = document.createElement('script');
      script.id = 'google-translate-script';
      script.type = 'text/javascript';
      script.async = true;
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      document.body.appendChild(script);
    }
  }, [footerLinks]);




  return (
    <footer className="footer-nav">
      <div className="footer-column">
        <h3>{footerData.titles?.quick || DEFAULT_FOOTER_TITLES.quick}</h3>
        <ul>
          {footerData.quick && footerData.quick.length > 0 &&
            footerData.quick.map((item, i) => (
              <li key={i}>
                {isExternalLink(item.link) ? (
                  <a href={item.link} target="_blank" rel="noreferrer">{item.title}</a>
                ) : (
                  <Link to={item.link}>{item.title}</Link>
                )}
              </li>
            ))
          }
        </ul>
      </div>

      <div className="footer-column">
        <h3>{footerData.titles?.another || DEFAULT_FOOTER_TITLES.another}</h3>
        <ul>
          {footerData.another && footerData.another.length > 0 &&
            footerData.another.map((item, i) => (
              <li key={i}>
                {isExternalLink(item.link) ? (
                  <a href={item.link} target="_blank" rel="noreferrer">{item.title}</a>
                ) : (
                  <Link to={item.link}>{item.title}</Link>
                )}
              </li>
            ))
          }
        </ul>
      </div>

      <div className="footer-column">
        <h3>{footerData.titles?.more || DEFAULT_FOOTER_TITLES.more}</h3>
        <ul>
          {footerData.more && footerData.more.length > 0 &&
            footerData.more.map((item, i) => (
              <li key={i}>
                {isExternalLink(item.link) ? (
                  <a href={item.link} target="_blank" rel="noreferrer">{item.title}</a>
                ) : (
                  <Link to={item.link}>{item.title}</Link>
                )}
              </li>
            ))
          }
        </ul>
      </div>

      <div className="footer-column">
        <h3>{footerData.titles?.additional || DEFAULT_FOOTER_TITLES.additional}</h3>
        <ul>
          {footerData.additional && footerData.additional.length > 0 &&
            footerData.additional.map((item, i) => (
              <li key={i}>
                {isExternalLink(item.link) ? (
                  <a href={item.link} target="_blank" rel="noreferrer">{item.title}</a>
                ) : (
                  <Link to={item.link}>{item.title}</Link>
                )}
              </li>
            ))
          }
        </ul>
      </div>

      {/* Google Translate widget (original language select input) - always in DOM, hidden on non-touch devices */}
      <div className={
        "footer-translate-wrapper" + (!isTouchDevice() ? " hide-on-desktop" : "")
      }>
        <div className="footer-translate-row footer-translate-row1">
          <div id="google_translate_element" className="footer-translate-widget"></div>
        </div>
        <div className="footer-translate-row footer-translate-row2">
          <div className="footer-translate-label">
            🌐 <strong>Choose/Change Language:</strong>
            <span className="footer-translate-desc"> (Select your preferred language below)</span>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 JOBFIND24 . All rights reserved. | <Link to="/privacy-policy">Privacy Policy</Link> | <Link to="/terms-of-service">Terms of Service</Link></p>
      </div>
    </footer>
  );
}

export default Footer;
